module.exports = __webpack_public_path__ + "img/66.c2258da2.svg";